import React, { useMemo, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { useAuth } from '../contexts/AuthContext';
import { auth } from '../views/firebaseConfig';
import navWorld from '../assets/android/ui/p4r_nav_world_eye.svg';
import navShop from '../assets/android/ui/p4r_nav_shop.svg';
import navPlayers from '../assets/android/brand/p4r_nav_shark_center.png';
import navBucks from '../assets/android/ui/p4r_nav_bucks.svg';
import navChat from '../assets/android/ui/p4r_nav_chat.svg';
import profileAsset from '../assets/android/ui/p4r_concept_profile.svg';
import './Navbar.css';

const tabs = [
  { path: '/feed', label: 'World', icon: navWorld },
  { path: '/shoparound', label: 'Shop', icon: navShop },
  { path: '/players', label: 'Players', icon: navPlayers, center: true, protected: true },
  { path: '/bucks', label: "Buck's", icon: navBucks, protected: true },
  { path: '/messages', label: 'Messages', icon: navChat, protected: true },
];

const poolPalette = ['#f2c200', '#2563eb', '#e53935', '#7c1cff', '#ff8c1a', '#16a34a', '#f8f8f8'];

export default function Navbar() {
  const { user, profile, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [accents, setAccents] = useState({});

  const displayName = profile?.nickname || profile?.displayName || profile?.name || 'Pool Player';
  const photo = profile?.profileImageUrl || profile?.photoUrl || '';

  const selectedPath = useMemo(() => {
    if (location.pathname.startsWith('/shoparound')) return '/shoparound';
    if (location.pathname.startsWith('/players') || location.pathname === '/profile') return '/players';
    if (location.pathname.startsWith('/bucks') || location.pathname.startsWith('/teams') || location.pathname.startsWith('/tournaments') || location.pathname.startsWith('/race-room')) return '/bucks';
    if (location.pathname.startsWith('/messages')) return '/messages';
    return '/feed';
  }, [location.pathname]);

  const activate = (tab) => {
    if (tab.protected && !user) {
      navigate('/login');
      return;
    }
    const current = accents[tab.path];
    const choices = poolPalette.filter((color) => color !== current);
    setAccents((value) => ({ ...value, [tab.path]: choices[Math.floor(Math.random() * choices.length)] }));
    navigate(tab.path);
  };

  const handleSignOut = async () => {
    await signOut(auth);
    navigate('/');
  };

  return (
    <header className="p4r-top-rail-shell">
      <div className="p4r-top-rail" role="navigation" aria-label="Pool 4 Real primary navigation">
        {tabs.map((tab) => {
          const selected = selectedPath === tab.path;
          const accent = accents[tab.path] || (tab.center ? '#7c1cff' : '#c4b5fd');
          return (
            <button
              key={tab.path}
              type="button"
              className={`p4r-top-tab ${tab.center ? 'is-center' : ''} ${selected ? 'is-selected' : ''}`}
              onClick={() => activate(tab)}
              style={{ '--p4r-tab-accent': accent }}
              aria-current={selected ? 'page' : undefined}
              title={tab.label}
            >
              <span className="p4r-top-tab-glow" aria-hidden="true" />
              <span className="p4r-top-tab-lens">
                <img src={tab.icon} alt="" />
              </span>
              <span className="p4r-top-tab-label">{tab.label}</span>
            </button>
          );
        })}
      </div>

      <div className="p4r-top-account">
        {loading ? (
          <span className="p4r-top-account-loading">Checking…</span>
        ) : user ? (
          <>
            <Link to="/profile" className="p4r-top-profile" title="View my player profile">
              {photo ? <img src={photo} alt="" /> : <img src={profileAsset} alt="" />}
              <span><strong>{displayName}</strong><small>View profile</small></span>
              <i aria-label="Online" />
            </Link>
            <button type="button" className="p4r-top-signout" onClick={handleSignOut}>Sign out</button>
          </>
        ) : (
          <Link className="p4r-top-signin" to="/login">Sign in</Link>
        )}
      </div>
    </header>
  );
}
